import BackofficeController from "backoffice_controller";

export default class extends BackofficeController {
  static targets = ["pdfSelector", "pdfContainer", "pdfPlaceholder"];

  connect() {}

  choosePdf(event) {
    event.preventDefault();
    this.pdfSelectorTarget.click();
  }

  handlePreview(event) {
    const file = event.target.files[0];
    if (!file) return;

    if (file.type !== 'application/pdf') {
      alert('Seuls les fichiers PDF sont acceptés');
      event.target.value = '';
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      alert('Le fichier ne doit pas dépasser 10 Mo');
      event.target.value = '';
      return;
    }

    if (this.hasPdfPlaceholderTarget) {
      this.pdfPlaceholderTarget.classList.add("d-none");
    }

    const existingPdfInfo = this.pdfContainerTarget.querySelector('.pdf-info');
    if (existingPdfInfo) {
      existingPdfInfo.remove();
    }

    const pdfInfo = document.createElement('div');
    pdfInfo.className = 'pdf-info d-flex align-items-center mb-2';
    pdfInfo.innerHTML = `
      <span class="text-decoration-none">${file.name}</span>
      <small class="text-muted ms-2">(${this.formatFileSize(file.size)})</small>
    `;

    this.pdfContainerTarget.insertBefore(pdfInfo, this.pdfSelectorTarget);

    const button = this.pdfContainerTarget.querySelector('button');
    if (button) {
      button.textContent = "Remplacer le PDF";
    }
  }

  removePdf(_event) {
    if (confirm('Êtes-vous sûr de vouloir supprimer ce fichier ?')) {
      this.pdfSelectorTarget.value = '';

      const hiddenInput = this.element.querySelector('input[type="hidden"][name*="schedule_pdf"]');
      if (hiddenInput) {
        hiddenInput.value = '';
      }

      const removeInput = document.createElement('input');
      removeInput.type = 'hidden';
      removeInput.name = hiddenInput ? hiddenInput.name.replace('[schedule_pdf]', '[remove_schedule_pdf]') : 'service[remove_schedule_pdf]';
      removeInput.value = '1';
      this.element.appendChild(removeInput);

      const existingPdfInfo = this.pdfContainerTarget.querySelector('.pdf-info');
      if (existingPdfInfo) {
        existingPdfInfo.remove();
      }

      if (this.hasPdfPlaceholderTarget) {
        this.pdfPlaceholderTarget.classList.remove("d-none");
      }

      const button = this.pdfContainerTarget.querySelector('button');
      if (button && button.textContent === "Remplacer le PDF") {
        button.textContent = "Choisir un fichier PDF";
      }
    }
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}